// Tick minute partagé T1/Production (correctif binding gate 7b) : force un
// re-rendu ALIGNÉ SUR LA MINUTE PLEINE pour que les messages de délai (§2) et
// les bandeaux de charge évoluent sans navigation ni interaction. Un re-rendu
// n'est PAS une animation : zéro animation CSS, zéro écriture DB, zéro
// dépendance. Retourne `Date.now()` figé au dernier tick — à passer comme `now`
// aux projections pures du moteur (déterminisme en fake timers).
import { useEffect, useState } from 'react';

const MS_MIN = 60_000;

export function useMinuteTick(): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const planifier = (): void => {
      const t = Date.now();
      const prochaineMinute = (Math.floor(t / MS_MIN) + 1) * MS_MIN;
      timer = setTimeout(() => {
        setNow(Date.now());
        planifier();
      }, Math.max(1, prochaineMinute - t));
    };
    planifier();
    return () => clearTimeout(timer);
  }, []);

  return now;
}
